import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[var(--bg-deep)] py-16" data-id="element-89" data-mp="3gfsmscqd8umz">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-90" data-mp="3ggk6oqalp3xf">
        <p className="text-sm font-semibold uppercase tracking-[0.25em] text-[var(--rose)]" data-id="element-91" data-mp="32onk11rpbm8f">
          🧘 Tu Plataforma Digital™
        </p>
        <p className="mt-3 font-serif-display text-3xl font-bold text-[var(--text)]" data-id="element-92" data-mp="36ppj9ilmbyae">
          Pilates Clinic
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[var(--text-soft)]" data-id="element-93" data-mp="38qw2zmvrtrp">
          El sistema número uno para profesoras y profesores de Pilates en
          Argentina.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[var(--text-soft)]" data-id="element-94" data-mp="3le2f8fkphh4w">
          Porque trabajar con alumnos limitados no debería costarte miedo legal,
          incertidumbre, domingos de ansiedad ni ganancias perdidas.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-[var(--text)]/85" data-id="element-95" data-mp="2ey09s9ubckip">
          <a href="mailto:soportetuplataformadigital@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-[var(--rose)]" data-id="element-96" data-mp="3l8qwo57filrz">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="3v8rfzr5at1w6" />
            soportetuplataformadigital@gmail.com
          </a>
          <a href="https://www.tuplataformadigital.store" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-[var(--rose)]" data-id="element-98" data-mp="3q7bvq1ay2zeu">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-99" data-mp="hrs6dddea152" />
            www.tuplataformadigital.store
          </a>
        </div>

        <div className="mt-10 border-t border-[var(--line)] pt-8" data-id="element-100" data-mp="cuija4dha1ke">
          <p className="text-xs text-[var(--text-soft)]" data-id="element-101" data-mp="qujk5jtqt8zv">
            © Tu Plataforma Digital™ 2026 — Todos los derechos reservados.
          </p>
          <p className="mt-6 font-serif-display text-xl italic text-[var(--rose)]" data-id="element-102" data-mp="mq3ftmzs29mr">
            “Tu especialidad en adaptaciones es tu mayor ventaja competitiva.”
          </p>
        </div>
      </div>
    </footer>;
}